import axios from 'axios';

const BASE = '/api/crm-web/quotations';

function authHeaders() {
  // [F2] Sesion por cookie httpOnly (same-origin): el browser la adjunta solo.
  return {};
}

export const quotationCatalogAPI = {
  getProducts: () => axios.get(`${BASE}/catalog/products`, authHeaders()).then(r => r.data.data),
  getKits: () => axios.get(`${BASE}/catalog/kits`, authHeaders()).then(r => r.data.data),
  getCampaigns: () => axios.get(`${BASE}/catalog/campaigns`, authHeaders()).then(r => r.data.data),
  getCampaignPrices: (id) => axios.get(`${BASE}/catalog/campaigns/${id}/prices`, authHeaders()).then(r => r.data.data),
  getAgents: () => axios.get(`${BASE}/catalog/agents`, authHeaders()).then(r => r.data.data),
};

export const quotationsAPI = {
  list: (params = {}) => axios.get(BASE, { ...authHeaders(), params }).then(r => r.data),
  get: (id) => axios.get(`${BASE}/${id}`, authHeaders()).then(r => r.data.data),
  create: (data) => axios.post(BASE, data, authHeaders()).then(r => r.data.data),
  update: (id, data) => axios.put(`${BASE}/${id}`, data, authHeaders()).then(r => r.data.data),
  delete: (id) => axios.delete(`${BASE}/${id}`, authHeaders()).then(r => r.data),
};

export const quotationContactsAPI = {
  search: (q) => axios.get(`${BASE}/contacts/search`, { ...authHeaders(), params: { q } }).then(r => r.data.data),
};

export const quotationAdminAPI = {
  createProduct: (data) => axios.post(`${BASE}/admin/products`, data, authHeaders()).then(r => r.data.data),
  updateProduct: (id, data) => axios.put(`${BASE}/admin/products/${id}`, data, authHeaders()).then(r => r.data.data),
  deleteProduct: (id) => axios.delete(`${BASE}/admin/products/${id}`, authHeaders()),
  createCampaign: (data) => axios.post(`${BASE}/admin/campaigns`, data, authHeaders()).then(r => r.data.data),
  updateCampaign: (id, data) => axios.put(`${BASE}/admin/campaigns/${id}`, data, authHeaders()).then(r => r.data.data),
  updateCampaignPrices: (id, prices) => axios.put(`${BASE}/admin/campaigns/${id}/prices`, { prices }, authHeaders()),
  createKit: (data) => axios.post(`${BASE}/admin/kits`, data, authHeaders()).then(r => r.data.data),
  updateKit: (id, data) => axios.put(`${BASE}/admin/kits/${id}`, data, authHeaders()).then(r => r.data.data),
  deleteKit: (id) => axios.delete(`${BASE}/admin/kits/${id}`, authHeaders()),
};
